import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Link } from "react-router-dom";
import {
  formatNumber,
  truncateToTwoDecimals,
} from "../../../../../../utility/helper";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { wealthAssetTypeOption } from "../../../../../../utility/data";

const AssetTable = ({
  viewAssetDetails,
  onSelectAsset,
  limit,
  setPage,
  page,
}) => {
  const assetArray =
    viewAssetDetails?.table_data &&
    typeof viewAssetDetails.table_data === "object"
      ? Object.entries(viewAssetDetails.table_data).map(([key, value]) => ({
          assetClass: value.asset_class,
          selection: value.percentage,
          performance: value.performance_value,
          value: value.current_value,
        }))
      : [];

  const assetClassTemplate = (rowData) => {
    const matched = wealthAssetTypeOption?.find(
      (item) => item.value === rowData.assetClass
    );

    return (
      <div className="text-secondary">
        <Link onClick={() => onSelectAsset(rowData.assetClass)}>
          {matched ? matched.name : rowData.assetClass || "-"}
        </Link>
      </div>
    );
  };

  const performanceTemplate = (rowData) => {
    return (
      <div>{formatNumber(rowData.performance ? rowData.performance : "0")}</div>
    );
  };

  const selectionTemplate = (rowData) => {
    return (
      <div>
        {rowData.selection != null
          ? `${formatNumber(truncateToTwoDecimals(rowData.selection))}%`
          : "0"}
      </div>
    );
  };

  const valueTemplate = (rowData) => {
    return (
      <div>
        {rowData.value != null
          ? `${formatNumber(truncateToTwoDecimals(rowData.value))}`
          : "-"}
      </div>
    );
  };

  return (
    <>
      <div className="flex justify-around text-lightPrimary dark:text-white md:my-12 md:gap-1 gap-4 max-w-lg font-bold">
        <span>Consolidated Wealth</span>
        <span>
          {formatNumber(viewAssetDetails?.consolidated_wealth || 0)} CHF
        </span>
      </div>

      <DataTable
        value={assetArray}
        className="transaction mt-3"
        sortMode="multiple"
        totalRecords={assetArray?.length}
        emptyMessage="No data available"
      >
        <Column
          field="assetClass"
          header="Asset Class"
          body={assetClassTemplate}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-white font-light"
        />
        <Column
          field="selection"
          header="% of Selection"
          body={selectionTemplate}
          align={"right"}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-white font-light"
        />
        <Column
          field="performance"
          header="Performance in CHF"
          body={performanceTemplate}
          align={"right"}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-white font-light"
        />
        <Column
          field="value"
          header="Value in CHF"
          body={valueTemplate}
          align={"right"}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-white font-light"
        />
      </DataTable>

      {assetArray.length > limit && (
        <div
          className={`flex gap-3 items-center px-3 pt-10 text-secondary ${
            page > 0 ? "justify-between" : "justify-end"
          }`}
        >
          {page > 0 && (
            <button
              onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
              className="flex items-center gap-1"
            >
              <FaArrowLeft />
              View Previous
            </button>
          )}
          {page < Math.floor(assetArray.length / limit) && (
            <button
              onClick={() =>
                setPage((prev) =>
                  Math.min(prev + 1, Math.floor(assetArray.length / limit))
                )
              }
              className="flex items-center gap-1"
            >
              View Next
              <FaArrowRight />
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default AssetTable;
